"use client";

import React from "react";
import { CircleCheck, ArrowRight } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const deliveryBlocks = [{
  id: "chiropractic",
  title: "Chiropractic Care",
  description: "Expert spinal care designed to restore your body's natural alignment and improve overall nervous system function for lasting health.",
  feature1: "Precision spinal adjustments",
  feature2: "Posture correction therapy",
  feature3: "Evidence-based clinical care"
}, {
  id: "holistic",
  title: "Holistic Therapies",
  description: "Integrating traditional acupuncture and massage to address muscular tension and promote deep physiological healing and balance.",
  feature1: "Traditional & cosmetic acupuncture",
  feature2: "Deep tissue massage therapy",
  feature3: "Targeted dry needling techniques"
}];
export default function DeliveryOptions() {
  const {
    ref: sectionRef,
    isVisible: isSectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="165503" id="service-categories-overview" className="bg-background py-16 md:py-24 overflow-hidden" ref={sectionRef}>
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {}
          <div ref={imageRef} className={`relative h-[400px] lg:h-[600px] rounded-2xl overflow-hidden shadow-xl transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609030/img/delivery_professional_action.png" alt="Professional Healthcare Treatment at Bodywerks Clinic" className="object-cover w-full h-full hover:scale-105 transition-transform duration-700" />
            <div className="absolute inset-0 bg-gradient-to-t from-primary/40 to-transparent pointer-events-none" />
          </div>

          {}
          <div className={`transition-all duration-1000 delay-300 ease-out ${isSectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="mb-10">
              <h2 className="font-serif text-4xl md:text-5xl font-medium text-foreground relative inline-block mb-6 pb-2">
                Tailored Treatment Pathways
                <span className="absolute bottom-0 left-0 w-16 h-[2px] bg-accent rounded-full" />
              </h2>
              <p className="font-sans text-lg leading-relaxed text-muted-foreground max-w-lg">
                At Bodywerks, we combine clinical expertise with Mediterranean warmth. Our multi-disciplinary approach ensures you receive the highest standard of care in Cyprus.
              </p>
            </div>

            <div className="space-y-6">
              {deliveryBlocks.map((block, index) => <Card key={block.id} data-index={index} className="border-none shadow-sm bg-card rounded-2xl hover:shadow-md transition-shadow duration-300">
                  <CardHeader className="pb-3">
                    <CardTitle className="font-serif text-2xl font-medium text-foreground">
                      {block.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="font-sans text-base leading-relaxed text-muted-foreground mb-5">
                      {block.description}
                    </p>
                    <ul className="space-y-3">
                      {[block.feature1, block.feature2, block.feature3].map((feature, fIndex) => <li key={fIndex} data-index={fIndex} className="flex items-start gap-3">
                          <CircleCheck className="text-accent size-5 shrink-0 mt-0.5" />
                          <span className="font-sans text-base leading-relaxed text-foreground font-medium">
                            {feature}
                          </span>
                        </li>)}
                    </ul>
                  </CardContent>
                </Card>)}
            </div>

            <div className="mt-10">
              <Button asChild size="lg" className="rounded-full px-8 bg-accent hover:bg-accent/90 text-accent-foreground transition-transform hover:scale-105">
                <Link to="/TreatmentsPage">
                  Explore All Treatments
                  <ArrowRight className="ml-2 size-4" />
                </Link>
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}